import { gql } from "@apollo/client";

export const CREATE_PASSWORD_QUESTION = gql`
  mutation createPassWordQuestion($input: createPassWordQuestionInput) {
    createPassWordQuestion(input: $input) {
      Id
    }
  }
`;

export const GET_PASSWORD_QUESTION_BY_EMAIL = gql`
  query passWordQuestionByEmail($email: String!) {
    passWordQuestionByEmail(email: $email) {
      userId
      Id
      questions
      orgId
      message
    }
  }
`;

export const ANSWER_CHECKING = gql`
  mutation Answerchecking($input: updatePassWordQuestionInput) {
    answerchecking(input: $input)
  }
`;
